import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=c6dbab20&"
import script from "./DefaultPage.vue?vue&type=script&lang=js&"
export * from "./DefaultPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6dbab20')) {
      api.createRecord('c6dbab20', component.options)
    } else {
      api.reload('c6dbab20', component.options)
    }
    module.hot.accept("./DefaultPage.vue?vue&type=template&id=c6dbab20&", function () {
      api.rerender('c6dbab20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultPage.vue"
export default component.exports